import styled from 'styled-components';

export const PhotographyWrapper = styled.div`
  background-color: #ffffff;
  padding: 0px;
  margin: 0px;
`;
